import { useCallback } from "react";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { Stack } from "@fluentui/react/lib/Stack";

import { IKeyValue } from "Components/Generic/KeyValueGrid/IKeyValue";
import { ItemKeyValueGrid } from "Components/Generic/KeyValueGrid/ItemKeyValueGrid";
import { Value } from "Components/Generic/KeyValueGrid/Value";
import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { WithTranslator } from "Components/Generic/Translator";
import { getItemType } from "Utils/Item";
import { WithConfiguration } from "Components/Generic/Configuration";
import { WithMergeContext } from "../MergeContext/WithMergeContext";
import { IValidateContentProps } from "./IValidateContentProps";
import { useValidateContentStyles } from "./UseValidateContentStyles";

export const ValidateContent = WithTheme(
  WithMergeContext(
    WithConfiguration(
      WithTranslator((props: IValidateContentProps): JSX.Element => {
        const {
          config,
          mergedProjectItem,
          onPrevious,
          onMergeSave,
          translator,
          theme: { spacing }
        } = props;
        const { styles, gridStyles } = useValidateContentStyles();
        const onMergeSaveInt = useCallback(() => {
          onMergeSave(mergedProjectItem[`@id`]);
        }, [mergedProjectItem, onMergeSave]);

        const entityType = getItemType(mergedProjectItem);
        const fieldNameList = config.getDCMergeFields(entityType).map(({ fieldName }) => fieldName);

        const items = fieldNameList.map<IKeyValue>((column) => ({
          key: column,
          value: <Value fieldName={column} item={mergedProjectItem} placeholder="-" />
        }));

        return (
          <Stack tokens={{ childrenGap: spacing.m }} className={styles.root}>
            <Stack.Item className={styles.grid}>
              <ItemKeyValueGrid entityType={entityType} header="&nbsp;" items={items} styleSet={gridStyles} />
            </Stack.Item>
            <Stack horizontal horizontalAlign="end" tokens={{ childrenGap: spacing.s1 }}>
              <DefaultButton onClick={onPrevious} iconProps={{ iconName: `ChevronLeft` }}>
                {translator.get(`generic.previous`, `Previous`)}
              </DefaultButton>
              <PrimaryButton onClick={onMergeSaveInt}>{translator.get(`generic.accept`, `Accept`)}</PrimaryButton>
            </Stack>
          </Stack>
        );
      })
    )
  )
);
